module.exports = __webpack_public_path__ + "static/brands-crafters-companion-logo-81f8a507b67fc5fa305cceadcc1e10c7.svg";